import { useEffect } from 'react'

import { Outlet, ScrollRestoration } from 'react-router'
import { Toaster } from 'sonner'

export function RootLayout() {
  const mql = window.matchMedia('(display-mode: standalone)')
  useEffect(() => {
    if (mql.matches) {
      document.title = ''
    }
  }, [])

  return (
    <>
      <Outlet />
      <Toaster position="top-right" />
      <ScrollRestoration />
    </>
  )
}
